import React, { useEffect } from "react";
import Select from "react-dropdown-select";
import { Field } from "formik";

import { Label } from "modules/primitives";

const PlantSelectWithOptions = ({ formikprops, plant, index }) => {
  useEffect(() => {
    const checkPlantModelExists = formikprops.values[plant.id];

    if (!checkPlantModelExists) {
      formikprops.setFieldValue(plant.id, {
        otherOptions: 'under_review'
      });
    }
  }, []);

  return (
    <div>
      <hr className="mt-4 mb-3" />
      <span className="font-weight-bold">{index}. {plant.name}</span>
      {
        plant.areas.length > 0 ? (
          <div className="mt-2">
            <Label>Areas</Label>
            <Select
              multi
              closeOnSelect
              values={formikprops.values[plant.id]?.selectedAreas || []}
              onChange={(val) => {
                formikprops.setFieldValue(plant.id, {
                  ...formikprops.values[plant.id] || {},
                  selectedAreas: val
                });
              }}
              options={plant.areas}
              labelField="area_name"
              valueField="area_id"
              placeholder="Areas"
              searchBy="area_name"
              style={{ border: "1px solid #e4e7eb" }}
            />
          </div>
        ) : null
      }
      <div className="form-check mt-2">
        <label className="form-check-label d-flex align-items-center">
          <Field
            className="form-check-input"
            type="radio"
            name={`otherOptions_${index}`}
            value="under_review"
            onChange={() => {
              formikprops.setFieldValue(plant.id, {
                ...formikprops.values[plant.id] || {},
                otherOptions: 'under_review'
              });
            }}
            checked={formikprops.values[plant.id]?.otherOptions === 'under_review'}
          />
          Possible Replication
        </label>
      </div>
      <div className="form-check">
        <label className="form-check-label d-flex align-items-center">
          <Field
            className="form-check-input"
            type="radio"
            name={`otherOptions_${index}`}
            value="different_solution"
            onChange={() => {
              formikprops.setFieldValue(plant.id, {
                ...formikprops.values[plant.id] || {},
                otherOptions: 'different_solution'
              });
            }}
            checked={formikprops.values[plant.id]?.otherOptions === 'different_solution'}
          />
          Different Solution in Place
        </label>
      </div>
      <div className="form-check">
        <label className="form-check-label d-flex align-items-center">
          <Field
            className="form-check-input"
            type="radio"
            name={`otherOptions_${index}`}
            value="not_applicable"
            onChange={() => {
              formikprops.setFieldValue(plant.id, {
                ...formikprops.values[plant.id] || {},
                otherOptions: 'not_applicable'
              });
            }}
            checked={formikprops.values[plant.id]?.otherOptions === 'not_applicable'}
          />
          Not Applicable for this Plant
        </label>
      </div>
    </div>
  );
};

export default PlantSelectWithOptions;
